export const TaskEndpoints = {
  getStatus: (taskName: string) => `/tasks/${taskName}`,
  list: '/tasks/list',
  // É dispensa, não exclusão de cadastro: por isso `/dismiss` e não o `/del/{id}` das outras rotas do backend.
  dismiss: (taskName: string) => `/tasks/dismiss/${taskName}`,
  dismissFinished: '/tasks/dismiss/all',
};
